import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Select } from 'components/fields'
import { Button } from 'components/misc'
import styles from './select-option.styl'

export default class SelectOption extends Component {
  static propTypes = {
    options: PropTypes.array.isRequired,
    values: PropTypes.object
  }
  static defaultProps = {
    options: []
  }

  render() {
    const { options, values } = this.props

    return (
      <div className={styles.wrap}>
        <div className={styles.select}>
          <Select
            name="awardLeader.id"
            label="Select a leader"
            options={options}
            labelless
            small
            hasFormGroup={false}
          />
        </div>
        <div className={styles.action}>
          <Button
            disabled={!get(values, 'awardLeader.id')}
            tiny
            intlKey="button.assign"
          >
            Assign
          </Button>
        </div>
      </div>
    )
  }
}
